<template>
  <transition name="fade">
    <div class="frontend">
      <transition name="fadeFirst" :mode="animationMode">
        <!-- Blend In LAT Logo for 1 second -->
        <div v-if="introStatus === 'Step-01-Logo'" key="2" class="startWrapper">
          <v-container>
            <v-row no-gutters justify="center" style="height: 90vh">
              <v-col cols="10" align-self="center">
                <v-img
                    id="latLogo"
                    alt="Lufthansa Aviation Training"
                    src="@/assets/images/lat_logo.png"
                />
              </v-col>
            </v-row>
          </v-container>
        </div>

        <!-- Show Then Start Screen -->
        <div
            v-else-if="introStatus === 'Step-02-Menu'"
            key="1"
            class="startWrapper"
        >
          <v-container fluid>
            <div style="height: 100vh; display: flex; align-items: center;justify-content: center">
              <login-form/>
            </div>
          </v-container>
        </div>
      </transition>
    </div>
  </transition>
</template>


<script>

import LoginForm from "../components/LoginForm";

export default {
  name: "TestView",
  components: {LoginForm},
  data: function () {
    return {
      introStatus: "Step-01-Logo",
      animationMode: "out-in",
      loadingPic: ""
    };
  },
  mounted: function () {
    //we do this setTimeOut to blend out the LAT Logo for 1 second in the beginning
    setTimeout(() => {
      this.introStatus = "Step-02-Menu";
    }, 1000);
  }
}
</script>

<style scoped>

/* Animation to next Page*/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Animation from Logo to Start Screen */
.fadeFirst-enter-active {
  transition: opacity 1s ease-in;
}

.fadeFirst-leave-active {
  transition: opacity 0.5s ease-out;
}

.fadeFirst-enter,
.fadeFirst-leave-to {
  opacity: 0;
}

.frontend {
  background-color: #dbecff;
  height: 100%;
}


</style>